import { URL_TYPES } from '@wix/wix-vod-constants/common';
export const parseChannelIdFromUrl = url => {
  if (!url) {
    return;
  }
  const idRegexp = '([\\w\\-]+)';
  let matched;

  /* Try to parse url as playlist */
  // Parse https://www.youtube.com/playlist?list=PL0y_aclKYoYifdQPQOw1mwVo0oKNMsg9E format
  matched = new RegExp(`youtube\\.com\\/.*list=${idRegexp}`).exec(url);
  if (matched) {
    return {
      id: matched[1],
      type: URL_TYPES.PLAYLIST
    };
  }

  /* Try to parse url as channel */
  // Parse https://www.youtube.com/channel/UCx96GiJ3qYw2sHccPp5dY_g format
  matched = new RegExp(`youtube\\.com\\/channel\\/${idRegexp}`).exec(url);
  if (matched) {
    return {
      id: matched[1],
      type: URL_TYPES.CHANNEL
    };
  }

  /* Try to parse url as user */
  // Parse https://www.youtube.com/user/wix format
  matched = new RegExp(`youtube\\.com\\/user\\/${idRegexp}`).exec(url);
  if (matched) {
    return {
      id: matched[1],
      type: URL_TYPES.USER_NAME
    };
  }

  /* Try to parse url as user again */
  // Parse https://www.youtube.com/user/wix format
  matched = new RegExp(`youtube\\.com\\/${idRegexp}$`).exec(url);
  if (matched) {
    return {
      id: matched[1],
      type: URL_TYPES.USER_NAME
    };
  }
  return;
};
//# sourceMappingURL=parse-youtube-url.js.map